var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1164_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8961 24.3194H22.7721C23.0173 23.395 23.3091 22.5673 23.4529 21.7144C24.0746 18.0379 23.0173 14.8698 20.4038 12.2102C20.1162 11.9202 20.0063 11.6387 20.0105 11.2438C20.0274 8.79839 20.0739 6.34881 20.002 3.90343C19.9344 1.75637 21.5626 -0.0125381 23.9224 6.69522e-05C31.3147 0.0378821 38.7029 0.00847031 46.0952 0.0168737C48.472 0.0168737 49.9817 1.51687 49.986 3.88242C49.9986 9.42864 49.9733 14.9749 49.9986 20.5211C50.0071 23.0463 48.0279 24.4665 46.091 24.3908C44.0738 24.311 42.0523 24.3614 40.0308 24.3866C39.7348 24.3866 39.4049 24.4959 39.1554 24.6555C37.2438 25.895 35.3408 27.1555 33.4504 28.4202C32.8795 28.8026 32.317 29.0967 31.6361 28.7144C30.9679 28.3404 30.8749 27.7186 30.8918 27.0337C30.913 26.1723 30.8961 25.311 30.8961 24.3236V24.3194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4597 45.9998C16.9762 45.9998 8.54776 45.9998 0.119272 45.9998C0.0981265 45.9746 0.055836 45.9451 0.055836 45.9199C0.0981265 43.672 -0.214823 41.4031 0.301121 39.1846C1.10464 35.7309 3.29951 33.3065 6.32328 31.5796C8.39974 30.3905 10.6369 29.6972 13.0517 29.7813C18.1181 29.9577 23.6497 33.4872 25.0664 38.693C25.2948 39.5334 25.4047 40.4199 25.4428 41.2897C25.502 42.6972 25.4597 44.1048 25.4597 45.5124C25.4597 45.6678 25.4597 45.8191 25.4597 45.9956V45.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.772 12.6387C16.7727 12.6429 20.029 15.8908 20.029 19.8656C20.029 23.832 16.7515 27.0883 12.7593 27.0925C8.75018 27.0967 5.46421 23.8193 5.47267 19.8278C5.48113 15.8656 8.76287 12.6345 12.772 12.6387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1164_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultant);
export default __webpack_public_path__ + "static/media/Consultant.792a87aecfd618ada6b9e2dd2cff1299.svg";
export { ForwardRef as ReactComponent };